<script>
import DomHelper from '@sbvr/common/legacy-shared/helpers/DomHelper';
import { FocusTrap } from 'focus-trap-vue';

export default {
  name: 'UIModal',
  provide () {
    return { modal: this };
  },
  components: {
    FocusTrap,
  },
  props: {
    open: { required: true, type: Boolean },
    preventScroll: { type: Boolean, default: true },
  },
  methods: {
    onMouseUp (e) {
      if (this.$refs.content !== e.target && !this.$refs.content.contains(e.target)) {
        !this.__shouldIgnoreClickEvent && this.close();
      }
    },
    onMouseDown (e) {
      this.__shouldIgnoreClickEvent = this.$refs.content === e.target || this.$refs.content.contains(e.target);
    },
    close () {
      this.$emit('close');
    },
    setupKeyBindings () {
      const vm = this;
      function handleEsc (e) {
        if (e.keyCode === 27) {
          vm.close();
        }
      }
      document.addEventListener('keydown', handleEsc);
      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', handleEsc);
      });
    },
    getInitialFocus () {
      return (this.$el.contains(document.activeElement) && document.activeElement) || this.$el;
    },
  },
  created () {
    this.$watch(
      () => this.preventScroll && this.open,
      () => {
        this.$nextTick(() => {
          const el = document.body;
          if (this.open && this.preventScroll) DomHelper.addClass(el, '-no-scroll');
          else DomHelper.removeClass(el, '-no-scroll');
        });
      },
      { immediate: true }
    );
    this.$watch('$route', () => { this.close(); });
    this.setupKeyBindings();
  },
};
</script>

<template>
  <FocusTrap :activate="open" :initial-focus="getInitialFocus">
    <transition :duration="350" name="modal" appear @after-leave="$emit('closed')">
      <div
        class="ui-modal fixed absolute--fill"
        v-show="open"
        tabindex="-1"
        @mousedown="onMouseDown"
        @mouseup="onMouseUp"
      >
        <div class="overlay flex items-start justify-center">
          <div class="content bg-white br3 mt5" ref="content">
            <slot>&nbsp;</slot>
          </div>
        </div>
      </div>
    </transition>
  </FocusTrap>
</template>

<style lang="postcss">
.-no-scroll {
  overflow: hidden;
}
</style>
<style scoped lang="postcss">
.ui-modal {
  z-index: 1000;
}
.overlay {
  min-height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  transition: opacity 0.25s ease-in-out;
}
.content {
  transition: all 0.35s ease-in-out;
  box-shadow: var(--lightDropShadow);
}

/* .modal-leave-active .overlay {
  transition-delay: 0.2s;
}
.modal-enter-active .content {
  transition-delay: 0.2s;
} */

.modal-enter,
.modal-leave-to {
  pointer-events: none;
  & .overlay {
    opacity: 0;
  }
  & .content {
    opacity: 0;
    transform: translateY(80px);
  }
}
.modal-enter-to,
.modal-leave {
  & .overlay {
    opacity: 1;
  }
  & .content {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
